<template>
  <div class="content__item-form-type content__item-form-type--paragraph">
    <span
      v-if="model.state.label.includes('href') && !model.state.useAction"
      class="content__item-form-group content__item-form-group--paragraph form-group"
      :class="paragraphClasses"
    >
      <RichTextRenderer :html="model.state.label" tag="span" />
    </span>
    <span
      v-else
      class="content__item-form-group content__item-form-group--paragraph form-group"
      :class="paragraphClasses"
      @click.prevent="onTextClicked"
    >
      <RichTextRenderer :html="model.state.label" tag="span" />
    </span>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { FormElementParagraphModel } from '@/src/components/addons/registration/Models/FormElementParagraphModel';
import { ActionType } from '@/src/typings/enums/enums';
import RichTextRenderer from '@/src/components/RichTextRenderer.vue';

export default defineComponent({
  name: 'FormElementParagraph',
  components: { RichTextRenderer },
  props: {
    model: {
      type: Object as PropType<FormElementParagraphModel>,
      required: true
    },

    showValidationErrors: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const model = props.model;
    const state = model.state;
    const onTextClicked = () => {
      state.action?.triggerAction();
    };

    const paragraphClasses = computed(() => {
      return {
        'content__item-form-group--paragraph-click': state.cta.type !== ActionType.NONE
      };
    });

    return {
      paragraphClasses,
      onTextClicked
    };
  }
});
</script>
